import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Api from "../api/Api";
import AdvancedList from "../controls/AdvancedList";
import SortButton from "../controls/SortButton";
import Page from "../layout/Page";
import { useNavigate } from "react-router";

export default function UserList() {

	let navigate = useNavigate();
	const [users, setUsers] = useState(null);

	useEffect(() => {
		Api.put('users/getusers', null, response => {
			setUsers(response.data.users);
		});
	}, []);

	const actions = <Link to="/users/new" className="btn btn-sm btn-primary"><em className="fa-solid fa-add"></em> {t.userNew}</Link>

	const status = {
		1: <span className="badge bg-success">{t.commonActive}</span>,
		2: <span className="badge bg-danger">{t.commonInactive}</span>
	}

	const renderHeader =
		<tr>
			<th><SortButton name="name" propertyName="lastName" default>{t.commonUser}</SortButton></th>
			<th width="200"><SortButton name="state" isNumber>{t.commonState}</SortButton></th>
		</tr>

	const renderCells = (user) => [
		`${user.lastName} ${user.firstName}`,
		status[user.state]
	]

	return (
		<Page title="userList" actions={actions}>
			<AdvancedList
				data={users}
				header={renderHeader}
				renderCells={renderCells}
				onRowClick={(user) => navigate(`/users/${user.id}`)}
				searchProperties={["lastName", "firstName"]}
				name="users"
			/>
		</Page>
	);
}